import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.url.includes('cdn.fino.cloud')) {
      request = request.clone({
        headers: request.headers.delete('Authorization'),
      });
    }
    return next.handle(request) as Observable<HttpEvent<any>>;
  }
}
